import React from "react";

const FollowIcon = () => {
  return (
    <svg
      width="19"
      height="20"
      viewBox="0 0 19 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M0.999999 18.5H0.499999L0.500001 19.5H1L0.999999 18.5ZM1 19.5H19L19 18.5H0.999999L1 19.5Z"
        fill="#3F3F3F"
      />
      <path
        d="M0.999999 0.5H0.499999L0.500001 1.5H1L0.999999 0.5ZM1 1.5H19L19 0.5H0.999999L1 1.5Z"
        fill="#3F3F3F"
      />
      <line
        y1="-0.5"
        x2="18"
        y2="-0.5"
        transform="matrix(0 -1 1 1.99114e-06 19 19)"
        stroke="#3F3F3F"
      />
      <path
        d="M1.5 10C1.5 9.72386 1.27614 9.50001 1 9.5C0.723858 9.5 0.5 9.72386 0.5 10L1.5 10ZM1.5 19L1.5 10L0.5 10L0.5 19L1.5 19Z"
        fill="#3F3F3F"
      />
      <path
        d="M0.517584 4.58545C0.518932 4.86159 0.74388 5.08435 1.02002 5.083C1.29616 5.08165 1.51892 4.85671 1.51757 4.58057L0.517584 4.58545ZM1.51757 4.58057L1.50008 0.997958L0.500094 1.00284L0.517584 4.58545L1.51757 4.58057Z"
        fill="#3F3F3F"
      />
      <line
        x1="9.75"
        y1="6"
        x2="9.75"
        y2="14"
        stroke="#3F3F3F"
        strokeLinecap="round"
      />
      <line
        x1="6"
        y1="9.5"
        x2="13.25"
        y2="9.5"
        stroke="#3F3F3F"
        strokeLinecap="round"
      />
    </svg>
  );
};

export default FollowIcon;
